import { Box, Typography, Stack } from '@mui/material';
import React from 'react';

import { theme } from '@app/theme';
import { Product } from '@app/types/catalog';
interface OrganizationInfoProps {
  product: Product;
}
export function OrganizationInfo({ product }: OrganizationInfoProps) {
  const rows = [
    {
      label: '取引形態',
      value: (
        <Stack>
          <Typography>{product.customFields.conditionsTransaction}</Typography>
          <Typography>
            {product.customFields.conditionsTransactionNote &&
              product.customFields.conditionsTransactionNote}
          </Typography>
        </Stack>
      ),
    },
    {
      label: '住所',
      value: product.customFields.companyAddress,
    },
    {
      label: '所属団体名',
      value: product.customFields.groupName,
    },
    {
      label: '免許番号',
      value: product.customFields.licenseNumber,
    },
    {
      label: '会社名',
      value: product.customFields.companyName,
    },
    {
      label: '問い合わせ',
      value: (
        <>
          <Typography>{product.customFields.contactAddress}</Typography>
          <Typography>{product.customFields.contactPhoneNumber}</Typography>
          <Typography component="span" variant="body2">
            {product.customFields.contactAdditional}
          </Typography>
        </>
      ),
    },
  ];
  if (typeof product.organization === 'string') {
    return null;
  }

  return (
    <Box>
      <Typography
        width="100%"
        bgcolor={theme.palette.blueAccent.main}
        color="white"
        px={2}
        height={36}
        fontWeight={600}
        borderRadius={15}
        display="flex"
        alignItems="center"
        variant="h6"
      >
        会社情報
      </Typography>
      <Stack spacing={2.5} maxWidth={1040} mx="auto" mt={6} pb={7} width="100%">
        {rows.map(({ label, value }, index) => (
          <Stack
            borderBottom={1}
            borderColor="#E0E0E0"
            key={index}
            direction={{ sm: 'row', xs: 'column' }}
            spacing={1}
            pb={2.5}
          >
            <Typography
              sx={{
                color: '#718CA0',
                fontWeight: 700,
                minWidth: 200,
                whiteSpace: 'nowrap',
              }}
            >
              {label}
            </Typography>
            <Box
              sx={{
                whiteSpace: 'pre-wrap',
              }}
            >
              {value}
            </Box>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
